/** @file menuHandlers: the handlers of `shellMenuBindings` (open the menu of the selection). */
import type { EditorStore } from '../state/editorTypes';
import { openMenuForSelection } from './openMenuForSelection';

/** Both chords call the same opener. */
export function menuHandlers(store: EditorStore): Record<string, () => void> {
  const open = (): void => { openMenuForSelection(store); };
  return { 'menu.context': open, 'menu.context.shiftF10': open };
}
